import React from 'react';
import PropTypes from 'prop-types';
import { buildMediaUrl } from '../../../../../../views/democracy/utils';

// Карточка санкции (.sanc): фон-картинка + стоимость + название + описание.
export default function SanctionCard({ sanction, onEdit }) {
    const bgUrl = sanction.media ? (sanction.media.mediaFileUrl || buildMediaUrl(sanction.media.url)) : null;

    return (
        <button
            type="button"
            className="sanc"
            style={bgUrl ? { backgroundImage: `url(${bgUrl})` } : undefined}
            onClick={onEdit}
        >
            <div className="sanc-top">
                <span className="sanc-cost">{sanction.cost}</span>
                <span className="sanc-name">{sanction.title}</span>
            </div>
            {sanction.description && <div className="sanc-desc">{sanction.description}</div>}
        </button>
    );
}

SanctionCard.propTypes = {
    sanction: PropTypes.shape({
        cost: PropTypes.number,
        title: PropTypes.string,
        description: PropTypes.string,
        media: PropTypes.object
    }).isRequired,
    onEdit: PropTypes.func.isRequired
};
